<template>
    <div v-loading="loading">
        <!-- 肯尼亚 -->
        <el-descriptions :column="2" border :labelStyle="{width:'15%'}" :contentStyle="{width:'35%'}">
            <el-descriptions-item label="公司代码">{{businessInfo.companyID}}</el-descriptions-item>
            <el-descriptions-item label="公司名">{{businessInfo.company}}</el-descriptions-item>
            <el-descriptions-item label="公司名标准">{{businessInfo.companyStd}}</el-descriptions-item>
            <el-descriptions-item label="公司电话">{{businessInfo.companyPhone}}</el-descriptions-item>
            <el-descriptions-item label="公司传真">{{businessInfo.companyFax}}</el-descriptions-item>
            <el-descriptions-item label="公司地址">{{businessInfo.companyAddress}}</el-descriptions-item>
            <el-descriptions-item label="临近地区">{{businessInfo.neighborhood}}</el-descriptions-item>
            <el-descriptions-item label="公司所在城市">{{businessInfo.companyCity}}</el-descriptions-item>
            <el-descriptions-item label="公司所在县区">{{businessInfo.companyRegion}}</el-descriptions-item>
            <el-descriptions-item label="时区名称">{{businessInfo.timezone}}</el-descriptions-item>
            <el-descriptions-item label="时区">{{businessInfo.hours}}</el-descriptions-item>
            <el-descriptions-item label="公司官网">{{businessInfo.website}}</el-descriptions-item>
            <el-descriptions-item label="公司Facebook账号">{{businessInfo.companyFacebook}}</el-descriptions-item>
            <el-descriptions-item label="谷歌地图">{{businessInfo.googleMaps}}</el-descriptions-item>
            <el-descriptions-item label="公司黄页">{{businessInfo.yellowpages}}</el-descriptions-item>
            <el-descriptions-item label="成立时间">{{businessInfo.lastUpdated}}</el-descriptions-item>
            <el-descriptions-item label="类别1">{{businessInfo.category1}}</el-descriptions-item>
            <el-descriptions-item label="类别2">{{businessInfo.category2}}</el-descriptions-item>
            <el-descriptions-item label="联系人">{{businessInfo.contact}}</el-descriptions-item>
            <el-descriptions-item label="联系人职位">{{businessInfo.contactPosition}}</el-descriptions-item>
            <el-descriptions-item label="联系人性别">{{businessInfo.contactGender}}</el-descriptions-item>
            <el-descriptions-item label="联系人邮箱">{{businessInfo.contactEmail}}</el-descriptions-item>
            <el-descriptions-item label="联系人电话">{{businessInfo.contactPhone}}</el-descriptions-item>
            <el-descriptions-item label="联系人传真">{{businessInfo.contactFax}}</el-descriptions-item>
            <el-descriptions-item label="联系人所在地区">{{businessInfo.contactRegion}}</el-descriptions-item>
            <el-descriptions-item label="联系人所在城市">{{businessInfo.contactCity}}</el-descriptions-item>
            <el-descriptions-item label="国家代码">{{businessInfo.countryCode}}</el-descriptions-item>
            <el-descriptions-item label="国家">{{businessInfo.country}}</el-descriptions-item>
        </el-descriptions>
    </div>
</template>

<script>
export default {
    data() {
        return {
            businessInfo: {},
            loading: false,
        };
    },
    methods: {
        getInfo(){
            let companyName = encodeURIComponent(this.$route.query.companyName);
            let country = this.$route.query.country;
            this.loading = true;
            this.$axios.get(`${this.$clueUrl}/BuyerLeads/GetBusinessInformation?country=${country}&company=${companyName}`).then((res) => {
                const { isSuccess, data } = res;
                this.loading = false;
                if (isSuccess) {
                    this.businessInfo = data;
                }
            });
        },
    },
    mounted() {
        this.getInfo();
    },
};
</script>

<style lang="scss" scoped>

</style>